
  import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { getOrdersDetailsAPI } from "../../../api/pahrmacy";
import LogoDark from "../../../images/logo.png";

const PrintInvoiceWithData = ({ orderId, userId, onDone } = {}) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!orderId) return;
    orderDetails();
  }, [orderId]);

  const orderDetails = () => {
    setIsLoading(true);
    getOrdersDetailsAPI({ orderId, userId })
      .then((res) => {
        if (res.data.status === true) {
          console.log(res, "resposne");

          setData(res.data.data);
        } else {
          toast.error(res.data.message);
        }
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (!data) return;
    const html = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <title>Invoice Print</title>
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />

  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet"/>
  <link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
/>



  <style>
    body {
      background: #fff;
      padding: 30px;
     font-family: "Inter", -apple-system, BlinkMacSystemFont, 
             "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;

    }
    .invoice-brand img {
      max-width: 150px;
      margin-bottom: 20px;
    }
    .invoice-head {
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
    }
      .text {
      width: 1083px;
      padding: 20px;
      margin: 50px auto; /* center horizontally */
     
      background-color: #fff;
    }
      .invoice-info {
  font-family: "Segoe UI", Arial, sans-serif;
  font-size: 14px;
  color: #4b6b99; /* soft blue like image */
  max-width: 400px;
}

.invoice-info .row {
 
 margin-bottom: 10px;
}

.invoice-info .row span:first-child {
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.invoice-info .row span:last-child {
  font-weight: 500;
  color: #2f4f7f;
}




    ul { list-style: none; padding: 0; margin: 0; }
    li { margin-bottom: 5px; }
    @media print { body { padding: 0; } }
  </style>
</head>

<body>
<div class = "text">
  <div class="invoice">

    <div class="invoice-brand text-center">
    <img src="${LogoDark}" />


    </div>

    <div class="invoice-head">
      <div>
        <strong style="color:#526484;">INVOICE TO</strong>
        <h4><b>${data.order.address.name}</b></h4>
        <p>
        <i class="fa fa-map-marker" style="color:#4CAF50; font-size:1.1em; padding-right:12px;"></i>
        <span style="
    display: inline-block;
    vertical-align: top;
    color: #526484;">
          ${data.order.address.addressLine1}
         <br />
          ${data.order.address.city},
          ${data.order.address.state},
           ${data.order.address.postalCode}
           </span>
         
        </p>
        <p>
      <i class="fa fa-phone" style="color:#4CAF50; font-size:1.1em; padding-right:12px;"></i>
        <span style="
    display: inline-block;
    vertical-align: top;
    color: #526484;">
        ${data.order.address.mobile}
        </p>
      </div>

      <div class="text-left">
        <h3 style= "text-transform: uppercase;
        color: #67a94f;
         font-size: 2rem;
        letter-spacing: -0.03em;
        font-weight: 700;">Invoice</h3>
        <div class="invoice-info">
        <div class="row"><p><span>INVOICE ID </span>  :  <span>${data.order.orderNum}</span></p></div>
        <div class="row"><p><span>DATE </span>  :   <span>${new Date(data?.order?.updatedAt).toLocaleDateString("en-GB")}</span></p></div>
        <div class="row"><p><span>PHARAMCY </span>  :   <span>${data?.order?.pharmacy?.store_name}</span></p></div>
       <div class="row"><p><span>GST </span>  :   <span>${data?.order?.pharmacy?.gst_number}</span></p></div>
        <div class="row"><p><span>CONTACT </span>  :   <span>${data?.order?.pharmacy?.mobile}</span></p></div>
        </div>
      </div>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th style="width:30%;
              color: #67a94f;
              font-size: 12px;
              text-transform: uppercase;
              border-top: 0;">Item</th>

         <th style="width:30%;
              color: #67a94f;
              font-size: 12px;
              text-transform: uppercase;
              border-top: 0;">Qty</th>

          <th style="width:30%;
              color: #67a94f;
              font-size: 12px;
              text-transform: uppercase;
              border-top: 0;">Price</th>

        

          <th class ="text-end" style="width:30%;
              color: #67a94f;
              font-size: 12px;
              text-transform: uppercase;
              border-top: 0;">Amount</th>
        </tr>
      </thead>
      <tbody>
        ${data.orderItems
          .map(
            (item) => `
          <tr>
            <td class = "color" style = "color: #526484">${item.medicineName}</td>
            <td class = "color" style = "color: #526484">${item.quantity}</td>
            <td class = "color" style = "color: #526484">₹${item.price}</td>
            <td class = "text-end"style = "color: #526484">₹${(item.price * item.quantity).toFixed(2)}</td>
          </tr>`,
          )
          .join("")}
      </tbody>
      <tfoot>
        <tr>
        <td class = "color" style = "color: #526484"></td>
          <td colspan="2" class="fw-bold" style = "color: #526484">Subtotal</td>
          <td class = "text-end" style = "color: #526484">₹${data.order.totalAmount}</td>
        </tr>
        <tr>
        <td class = "color" style = "color: #526484"></td>
          <td colspan="2" style = "color: #526484">Discount</td>
          <td class="text-end" style = "color: #526484">${data.order.discountAmount}</td>
        </tr>
        <tr>
        <td class = "color" style = "color: #526484"></td>
          <td colspan="2" class="fw-bold" style = "color: #526484">Grand Total</td>
          <td class="fw-bold text-end" style = "color: #526484">₹${data.order.totalAmount}</td>
        </tr>
      </tfoot>
    </table>

    <p class="fst-italic text-muted" style= "color: #526484 !important;
    font-size: 12px;
    font-style: italic;">
      Invoice was created on a computer and is valid without the signature and seal.
    </p>

  </div>

  <script>
    window.onload = function () {
      window.print();
    };
  </script>
  </div>
</body>
</html>
`;

    const printWindow = window?.open("", "_blank");
    printWindow.document.write(html);
    printWindow.document.close();
    onDone?.();
  }, [data]);

  return null;
};

export default PrintInvoiceWithData;
